import styled from 'styled-components';
import Divider from './core/Divider';
import React from 'react';

const Header = styled.div`
    min-height: 38px;
    padding: 0 24px;
`;

const Content = styled.div`
    padding: 0 24px;
`;

function Page({title, children, ...rest}) {
    return (
        <div {...rest}>
            <Header>
                <h3>{title}</h3>
                <Divider />
            </Header>
            <Content>
                {children}
            </Content>
        </div>
    )
}

export default Page;